<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>飞艇事件配置</span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:airShip:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="等级">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="'Lv:'+tabItem.label">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="等级">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form :inline="true">
                        <el-row v-for="(item, score_index) in scoreItem.data" :key="score_index">
                          <el-form-item label="速度">
                            <el-input v-model.number="item.conf.speed" style="width: 200px;" placeholder="事件标题" />
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" style="margin-left: 16px;" @click="drawerArr[tabItem.label][scoreItem.group_name][score_index].visible = true">
                              奖励配置
                            </el-button>
                            <el-drawer
                              title="奖励配置"
                              :visible.sync="drawerArr[tabItem.label][scoreItem.group_name][score_index].visible"
                              direction="rtl"
                              size="600px"
                              :before-close="(v)=>handleClose(v,tabItem.label,scoreItem.group_name,score_index)"
                            >
                              <el-form :inline="true">
                                <el-row v-for="(conf,i) in item.conf.conf" :key="i" style="margin-top: 10px">
                                  <el-form-item label="数量">
                                    <el-input v-model.number="conf.num" style="width: 100px;" placeholder="数量" />
                                  </el-form-item>

                                  <el-form-item label="金币">
                                    <el-input v-model.number="conf.money" style="width: 100px;" placeholder="金币" />
                                  </el-form-item>

                                  <el-form-item label="权重">
                                    <el-input v-model.number="conf.v" style="width: 100px;" placeholder="权重" />
                                  </el-form-item>

                                  <el-form-item>
                                    <el-button type="danger" @click="delReward(tabItem.label,scoreItem.group_name,i)">删除</el-button>
                                  </el-form-item>
                                </el-row>
                                <el-button style="margin-top: 10px" type="primary" @click="addReward(tabItem.label,scoreItem.group_name)">+</el-button>
                              </el-form>
                            </el-drawer>
                          </el-form-item>
                          <el-form-item />
                        </el-row>
                        <el-button v-if="scoreItem.data.length <= 0" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                        <el-button v-permisaction="['config:airShip:add']" type="primary" @click="onSubmit()">保存</el-button>
                        <el-button v-permisaction="['config:airShip:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name ,scoreItem.data[0].id)">删除</el-button>

                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import { delAirshipCfg, getAirshipCfgList, updateAirshipCfg } from '@/api/config/airship'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'

export default {
  name: 'AirShip',
  data() {
    return {
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      visibleArr: {},
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      drawerArr: {},
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {}
    }
  },
  created() {
    this.getGroup()
    this.getTables()
    this.getRewardTypeData()
    this.getChessBoardType()
  },
  methods: {
    onSubmit(noTips = false) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          console.log('activeName', this.activeName)
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          postFormDataCondition[key] = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            groups: scoreItem.group
          }

          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data
          }

          const _data = scoreItem.data[0]
          _data.stage = key
          _postData.push(_data)
        }
      }
      // console.log(_postData)
      const postCondition = JSON.stringify(postFormDataCondition)
      _postData = JSON.stringify(_postData)
      console.log('postCondition', postCondition)
      console.log('_postData', _postData)
      updateAirshipCfg({ name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(actName) {
      getAirshipCfgList().then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond
        for (const i in cond) {
          const val = cond[i]
          const levelName = val.start + '-' + val.end
          const scoreName = val.groups.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.visibleArr, levelName)) {
            this.$set(this.drawerArr, levelName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val.groups,
            'group_name': scoreName,
            'group_bak': val.groups,
            data: []
          })
          this.$set(this.drawerArr[levelName], scoreName, [])
          for (const ii in data) {
            const _event = data[ii]
            console.log('ii', _event)
            if (_event.stage === i) {
              this.drawerArr[levelName][scoreName].push({ visible: false })
              this.$set(this.formData[levelName][scoreName], 'data', [_event])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }

          this.levelActiveName = levelName
        }
      })
    },
    levelChange(newVal, isMin, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = bakMin + '-' + bakMax
      console.log('old', oldLevelName)
      let newLevelName = ''
      if (isMin) {
        newLevelName = newVal + '-' + bakMax
      } else {
        newLevelName = bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.drawerArr[oldLevelName]
      Vue.delete(this.drawerArr, oldLevelName)
      this.$set(this.drawerArr, newLevelName, oldVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    delEvent1(levelName, scoreName, index, ci, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[ci].config[i])
      this.formData[levelName][scoreName].data[index].config[ci].config = this.formData[levelName][scoreName].data[index].config[ci].config.filter((item, key) => {
        return i !== key
      })
    },
    addEventReward(levelName, scoreName, index, ci, i) {
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[ci].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent(levelName, scoreName) {
      if (this.formData[levelName][scoreName].data.length > 0) {
        this.msgError('已达上限')
        return
      }
      this.formData[levelName][scoreName].data.push({
        'id': 0,
        'conf': {
          speed: 1,
          conf: [{
            num: 0,
            money: 0,
            v: 0
          }]
        }
      })
      this.drawerArr[levelName][scoreName].push({ visible: false })
    },
    delEvent(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delAirshipCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.formData[levelName][scoreName].data = []
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      console.log(this.formData[score.level_name])
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })

        this.$set(this.drawerArr[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 弹窗事件
      this.drawerArr[score.level_name][scoreTag].push({ visible: false })
      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({
        'id': 0,
        'conf': {
          speed: 1,
          conf: [{
            num: 0,
            money: 0,
            v: 0
          }]
        }
      })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        this.msgError('等级已经存在')
        return
      }

      this.tabPane.push({
        'label': this.levelFormData.min_level + '-' + this.levelFormData.max_level,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.drawerArr, levelName, { visible: false })
      console.log(this.formData)
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawerArr[levelName][scoreName][index].visible = false
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addReward(levelName, groupName) {
      console.log(this.formData[levelName][groupName].data[0])
      this.formData[levelName][groupName].data[0].conf.conf.push(
        {
          num: 0,
          money: 0,
          v: 0
        }
      )
    }, delReward(levelName, groupName, i) {
      this.formData[levelName][groupName].data[0].conf.conf = this.formData[levelName][groupName].data[0].conf.conf.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      console.log('newGroupName', newGroupName)
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.drawerArr[levelName][oldGroupName]
      this.$delete(this.drawerArr[levelName], oldGroupName)
      this.$set(this.drawerArr[levelName], newGroupName, oldVisible)
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    smallChangeEvent(levelName, groupName, index, v, i) {
      console.log('smallChangeEvent', v)
      if (v === 3) {
        this.formData[levelName][groupName].data[index].config[i].eventType = 1
        this.formData[levelName][groupName].data[index].config[i].reward = []
      }

      if (v === 1) {
        this.formData[levelName][groupName].data[index].config[i].eventType = 0
        this.formData[levelName][groupName].data[index].config[i].reward = [{
          propsId: 1,
          skin: 0,
          num: 0,
          rtype: 2
        }]
      }
    },
    removeReward(levelName, scoreName, index, ci, i, pi) {
      this.formData[levelName][scoreName].data[index].config[ci].config[i].reward = this.formData[levelName][scoreName].data[index].config[ci].config[i].reward.filter((item, key) => {
        return pi !== key
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
